/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";

const EmptyHeroSlide = () => {

    return (
        <div
            className='hero-slide'
            style={{ backgroundColor: "#989898" }}
        >
            <div className='hero-content-container'>
                <h1> </h1>
                <div className='hero-description-wrapper' />
            </div>
        </div>
    );
};

export { EmptyHeroSlide };
